import bem from "easy-bem";
import type { StatusRestriction } from "features/restrictions/data/types";
import { RESTRICTION_LABELS } from "features/restrictions/data/types";
import React from "react";
import { formatDate } from "utils/basic";

import "./RestrictionBanner.css";

const cn = bem("restriction-banner");

type RestrictionBannerProps = {
  restrictions: StatusRestriction[];
  showAppealLink?: boolean;
};

const RestrictionBanner: React.FC<RestrictionBannerProps> = ({
  restrictions,
  showAppealLink = true,
}) => {
  if (!restrictions.length) return null;

  return (
    <div className={cn()}>
      {restrictions.map((restriction) => (
        <div
          key={restriction.id}
          className={cn("item")}
        >
          <span className={cn("label")}>
            {RESTRICTION_LABELS[restriction.type]}
          </span>

          {restriction.reason && (
            <span className={cn("reason")}>: {restriction.reason}</span>
          )}

          <span className={cn("expiry")}>
            {" "}
            (
            {restriction.expiresAt
              ? `до ${formatDate(restriction.expiresAt)}`
              : "бессрочно"}
            )
          </span>

          {showAppealLink && (
            <a
              className={cn("link")}
              href="/#/profile"
            >
              Обсудить с модератором
            </a>
          )}
        </div>
      ))}
    </div>
  );
};

export default RestrictionBanner;
